import { render, staticRenderFns } from "./PendenciaModal.vue?vue&type=template&id=33329825&scoped=true&"
import script from "./PendenciaModal.vue?vue&type=script&lang=js&"
export * from "./PendenciaModal.vue?vue&type=script&lang=js&"
import style0 from "./PendenciaModal.vue?vue&type=style&index=0&id=33329825&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33329825",
  null
  
)

export default component.exports